import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import { closeResourceModal, resourceModalSelector } from 'store/reducers/global/global-reducer';

import ResourceModal from '../ResourceModal';
import { ResourceModalHandlerContext } from './ResourceModalHandlerContext';
import { ResourceModalHandlerBackground } from './styled';
import useResourceModalPageLock from './useResourceModalPageLock';

interface ResourceModalHandlerProps {
  settings?: {
    shareLink?: string;
    onClose?: () => void;
  };
}

export default function ResourceModalHandler({ settings }: ResourceModalHandlerProps) {
  const dispatch = useDispatch();
  const resourceModal = useSelector(resourceModalSelector);

  useResourceModalPageLock(resourceModal.show, resourceModal.originScrollPosition);

  const handleClose = () => {
    settings?.onClose?.();
    dispatch(closeResourceModal({}));
  };
  return ReactDOM.createPortal(
    <ResourceModalHandlerContext.Provider value={{ settings }}>
      {resourceModal.show ? (
        <>
          <ResourceModal onClose={handleClose} resourceModal={resourceModal} />
          <ResourceModalHandlerBackground />
        </>
      ) : null}
    </ResourceModalHandlerContext.Provider>,
    document.getElementById('root') as HTMLElement
  );
}
